<div class="row">
  <div class="col-12" *ngIf="shipmentData.status === 'Manifest Failed' && ErrorHistoryMsg != ''">
    <label class="secondary-details p-0">{{
      'shipment.shipmentHistory.manifestFailedError' | translate
    }}</label>
    <p id="errorMsg" class="view-color">
      {{ ErrorHistoryMsg }}
    </p>
  </div>

  <div *ngIf="showWarnings">
    <label class="secondary-details p-0">{{
      'shipment.shipmentHistory.warnings' | translate
    }}</label>
    <ul>
      <li *ngFor="let warning of warningsError">{{ warning }}</li>
    </ul>
  </div>
  <div *ngIf="showValidationErrors">
    <label class="secondary-details p-0">{{
      'shipment.shipmentHistory.validationErrors' | translate
    }}</label>
    <ul>
      <li *ngFor="let eachError of validationErrors">{{ eachError }}</li>
    </ul>
  </div>
  <div class="col-12">
    <label class="secondary-details p-0"> {{ 'shipment.shipmentHistory.logs' | translate }}</label>

    <div [formGroup]="logsetailsForm" class="row">
      <div class="col-md-3 form-group">
        <label class="required-field">{{ 'shipment.shipmentHistory.logRequest' | translate }}</label
        >:
        <mat-select
          class="form-control"
          [placeholder]="'shipment.shipmentHistory.selectLogRequest' | translate"
          (selectionChange)="logTypeChanged($event.value)"
          formControlName="logType">
          <mat-option *ngFor="let eachLog of logRequestoptions" [value]="eachLog">
            {{ eachLog }}
          </mat-option>
        </mat-select>
        <app-error-component [controlName]="logsetailsForm.get('logType')"></app-error-component>
      </div>

      <!-- <div class="row col-md-3 form-group">
        <label class="col-auto m-0 p-0">Date:</label>
        <mat-form-field>
          <mat-label>Select date</mat-label>
          <mat-date-range-input [rangePicker]="picker" [max]="maxDate ? maxDate : today">
            <input
              matStartDate
              (dateChange)="setMaxDate()"
              placeholder="Start date"
              formControlName="startDate"
              readonly />
            <input matEndDate placeholder="End date" formControlName="endDate" readonly />
          </mat-date-range-input>
          <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker (closed)="resetMaxDate()" #picker></mat-date-range-picker>
        </mat-form-field>
      </div> -->

      <div class="col-4 pt-4 mt-2">
        <button
          class="primary-btn me-2 text-center"
          [disabled]="!logsetailsForm.valid"
          (click)="downloadLog(true)">
          {{ 'shipment.shipmentHistory.downloadLogs' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="col-12">
    <label class="secondary-details p-0">{{
      'shipment.shipmentHistory.SRHistory' | translate
    }}</label>
  </div>
  <div class="col-12 table-container">
    <table mat-table aria-describedby="shipments-history" [dataSource]="srHistoryData" matSort>
      <ng-container matColumnDef="fileId">
        <th id="fileid" mat-header-cell *matHeaderCellDef>
          {{ 'shipment.shipmentHistory.fileId' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.file_id }}</td>
      </ng-container>

      <ng-container matColumnDef="time">
        <th id="date" mat-header-cell *matHeaderCellDef>
          {{ 'shipment.shipmentHistory.uploadedDate&Time' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.uploaded_datetime | date : 'dd/MMM/yyyy hh:mm aa' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="shipmentDetails">
        <th id="shipmentDetails" mat-header-cell *matHeaderCellDef>
          {{ 'shipment.shipmentHistory.shipmentDetails' | translate }}
        </th>
        <td
          class="view-color"
          mat-cell
          *matCellDef="let element"
          (click)="showResponseBody(element)">
          {{ 'shipment.shipmentHistory.view' | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th id="status" mat-header-cell *matHeaderCellDef>
          {{ 'shipment.shipmentHistory.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" [ngStyle]="getStyle(element.status)">
          {{ element.status }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th id="action" mat-header-cell *matHeaderCellDef>
          {{ 'shipment.shipmentHistory.action' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            *ngIf="element.status == 'pending'"
            class="primary-btn"
            type="button"
            (click)="sentUpdateDocStatus(element, true)">
            {{ 'shipment.shipmentHistory.accept' | translate }}
          </button>
          <button
            *ngIf="element.status == 'pending'"
            class="ml-2 secondary-btn"
            type="button"
            (click)="sentUpdateDocStatus(element, false)">
            {{ 'shipment.shipmentHistory.reject' | translate }}
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row justify-content-center" *matNoDataRow>
        {{
          'shipment.shipmentHistory.noDataAvailable' | translate
        }}
      </tr>
    </table>
  </div>
</div>
